export const parkingBookingsSelector = state => state.whiteLabel.parkingBookings.get('parkingBookings');
export const parkingBookingsIsLoadingSelector = state => state.whiteLabel.parkingBookings.get('isLoading');
export const goToParkingFloorSelector = state => state.whiteLabel.parkingBookings.get('goToParkingFloor');
export const parkingBookingDatesSelector = state => state.whiteLabel.parkingBookings.get('bookingDates');
